




import {Component, Vue, Prop} from "vue-property-decorator"
import Chart from "chart.js"
import BaseGraph from "@/components/Graph/BaseGraph.vue"

const FONT_COLOR = "rgba(142, 145, 153, 1)"
const GRID_LINES_SETTING = {
  display        : true,
  drawOnChartArea: true,
  color          : "rgba(142, 145, 153, 0.2)",
  zeroLineColor  : "rgba(142, 145, 153, 1)"
}
const LINE_COLOR = {
  color          : "rgba(68, 209, 229, 1)",
  backgroundColor: "rgba(68, 209, 229, 0.5)"
}

@Component({components: {BaseGraph}})
export default class BarGraph extends Vue {

  @Prop({type: Array, default: []}) private labels!: string[]
  @Prop({type: Array, default: []}) private datasets!: any[]
  @Prop({type: Number, default: undefined}) private min!: number

  get chartData(): Chart.ChartData {
    return {
      labels  : this.labels,
      datasets: [{
        type           : "bar",
        data           : this.datasets,
        lineTension    : 0,
        borderColor    : LINE_COLOR.color,
        backgroundColor: LINE_COLOR.backgroundColor
      }]
    }
  }

  get chartOptions(): Chart.ChartOptions {
    return {
      responsive         : true,
      maintainAspectRatio: false,
      legend             : {
        display: false
      },
      layout             : {
        padding: {
          top   : 0,
          left  : 0,
          bottom: 0,
          right : 0
        }
      },
      scales             : {
        xAxes: [
          {
            gridLines : GRID_LINES_SETTING,
            ticks     : {
              autoSkip : true,
              fontColor: FONT_COLOR,
              fontSize : 14
            },
            scaleLabel: {
              display    : true,
              fontColor  : FONT_COLOR,
              labelString: "Date"
            }
          }
        ],
        yAxes: [
          {
            id        : "yAxis_1",
            type      : "linear",
            gridLines : GRID_LINES_SETTING,
            scaleLabel: {
              display    : true,
              fontColor  : FONT_COLOR,
              labelString: "Token Number"
            },
            ticks     : {
              autoSkip : true,
              fontColor: FONT_COLOR,
              fontSize : 14,
              min      : this.min,
              stepSize : 100
            }
          }
        ]
      }
    }
  }
}
